import React, {useState} from 'react';
import {AddFundsIcon, RightArrow} from '../SvgIcons/SvgIcons';
import {Checkbox, Radio, Spin,message} from 'antd';
import {PayPalButton} from 'react-paypal-button-v2';
import {useSelector} from 'react-redux';
import {UPDATE_BALANCE} from './../../../graphql/mutations/profile';
import {gql, useMutation} from '@apollo/client';

const AddFunds = ({ handleCancel }) => {
  const [amount, setAmount] = useState();
  const userProfile = useSelector((state) => state.strapiRes);
  const [updateBalance] = useMutation(gql(UPDATE_BALANCE));
  const [loader, setLoader] = useState(false);

  // console.log("userProfile", userProfile);

  const paymentSuccess = (details, data) => {
    if (amount) {
      setLoader(true);
      updateBalance({
        variables: {
          profileId: userProfile.id,
          balance: parseFloat(amount),
        },
      }).then((res) => {
        setLoader(false);
      }).catch((err) =>  message.error(err.message))
    }
  };

  return (
    <Spin spinning={loader} className="loading">
      <div className="purchase-intro-modal add-funds-modal">
        <div className="modal-card-top">
          <div>
            <h2 className="heading">Add funds</h2>
          </div>
          <AddFundsIcon />
        </div>
        <div className="funds-amount">
          <Radio.Group buttonStyle="solid">
            <Radio.Button
              value="$10"
              onClick={(e) => {
                setAmount(10);
              }}>
              <h2 className="small-heading">$10</h2>
            </Radio.Button>
            <Radio.Button
              value="$50"
              onClick={(e) => {
                setAmount(50);
              }}>
              <h2 className="small-heading">$50</h2>
            </Radio.Button>
            <Radio.Button
              value="$100"
              onClick={(e) => {
                setAmount(100);
              }}>
              <h2 className="small-heading">$100</h2>
            </Radio.Button>
          </Radio.Group>
          {/* <div className="checkbox-funds">
                    <Checkbox checked={amount == 10 ? "true" : "false"} onClick={(e) => { setAmount(10) }}><h2 className="small-heading">$10</h2></Checkbox>
                </div>
                <div className="checkbox-funds">
                    <Checkbox><h2 checked={amount == 50 ? "true" : "false"} onClick={(e) => { setAmount(50) }} className="small-heading">$50</h2></Checkbox>
                </div>
                <div className="checkbox-funds">
                    <Checkbox><h2 checked={amount == 100 ? "true" : "false"} onClick={(e) => { setAmount(100) }} className="small-heading">$100</h2></Checkbox>
                </div> */}
          <div className="input-field">
            <span className="icon">$</span>
            <input
              type="text"
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              placeholder="Enter Custom amount"
              value={amount}
            />
          </div>
        </div>
        <div>
          <label>Payment method</label>
          <div className="checkbox-container">
            <Checkbox>
              <div>
                <p>Account Balance</p>
                {!amount && (
                  <p className="error-msg">
                    Insufficient balance.{' '}
                    <a>
                      Add funds now
                      <RightArrow />
                    </a>
                  </p>
                )}
              </div>
              <h2 className="small-heading">${userProfile.balance}</h2>
            </Checkbox>
          </div>
          {amount && (
            <PayPalButton
              amount={amount}
              style={{color: 'white'}}
              onSuccess={paymentSuccess}
              catchError={(err) => {
                console.log('error in payment', err);
              }}
              options={{
                disableFunding: 'credit',
                clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
              }}
            />
          )}

          {/* <div className="checkbox-container">
                    <Checkbox>
                        <div>
                            <p>Apple Pay</p>
                        </div>
                        <img src={appleIcon} />
                    </Checkbox>
                </div>
                <div className="checkbox-container">
                    <Checkbox>
                        <div>
                            <p>PayPal</p>
                        </div>
                        <img src={PayPalIcon} />
                    </Checkbox>
                </div>
                <div className="checkbox-container mb-0">
                    <Checkbox>
                        <div>
                            <p>Credit Card</p>
                        </div>
                        <div className="d-flex align-items-center">
                            <img src={masterIcon} className="mr-2" />
                            <img src={visaIcon} />
                        </div>
                    </Checkbox>
                </div>
                <div className="credit-card-info">
                    <div className="card-list"><div className="card-icon"><img src={masterIcon} /></div><p>Master Card ending 4902</p></div>
                    <div className="card-list"><div className="card-icon"><img src={visaIcon} /></div><p>Visa Card ending 8882</p></div>
                    <div className="card-list"><div className="card-icon"><AddIcon /></div><p>Add new card </p></div>
                </div>
                <div className="add-card-info">
                    <div className="input-field">
                        <label>Name on card</label>
                        <input type="text" placeholder="Tim Jordan Smith" />
                    </div>
                    <div className="input-field">
                        <label>Card number</label>
                        <input type="text" placeholder="**** **** **** 1223" />
                    </div>
                    <div className="row m-0">
                        <div className="input-field col pl-0">
                            <label>Expiry date</label>
                            <input type="text" placeholder="11 / 22" />
                        </div>
                        <div className="input-field col">
                            <label>CVV</label>
                            <input type="text" placeholder="***" />
                        </div>
                        <div className="input-field col pr-0">
                            <label>Zip code</label>
                            <input type="text" placeholder="90120" />
                        </div>
                    </div>
                </div>*/}
        </div>
        <p className="policy-text">
          Other offers still stand until you mark introduction as completed. By
          continuing, you agree to the <a>terms</a> and <a>privacy policy</a>.
        </p>
        <div className="btn-row">
          <div className="col pl-0">
            <button className="btn-style cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
          <div className="col p-0">
            <button className="btn-style">Purchase intro</button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default AddFunds;
